/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_121b01b8"]'><cube-button open-type="chooseAvatar" tip="需在微信小程序环境预览" @chooseAvatar='(e)=>__invoke(e, [["onChooseAvatar"]])'>获取头像</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_121b01b8"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_121b01b8"}
  /** script content **/
  require("./btn-choose-avatar.mpx.js?isComponent&outputPath=components%2Fbtn-choose-avatar121b01b8%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./btn-choose-avatar.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbtn-choose-avatar121b01b8%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_121b01b8"],
    ctorType: "component",
    outputPath: "components/btn-choose-avatar121b01b8/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>